<template>
    <div>
        <div v-show="showExisting()" class="mt-2 flex justify-center px-6 pt-5 pb-6 border-2 rounded-md border-indigo-500">
            <div class="text-center">
                <div>
                    <img :src="existing" class="h-24" alt="">
                </div>
            </div>
        </div>

        <div @dragenter.prevent.stop="highlight=true" @dragover.prevent.stop="highlight=true"
             @dragleave.prevent.stop="highlight=false" @drop.prevent.stop="handleDrop($event)"
             class="mt-2 flex justify-center px-6 pt-5 pb-6 border-2 border-dashed rounded-md"
             :class="highlight ? 'border-indigo-500' : 'border-gray-300'"
        >
            <div class="text-center">
                <div v-show="uploadedSource === null">
                    <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor"
                         fill="none"
                         viewBox="0 0 48 48">
                        <path
                            d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                            stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                    <p class="mt-1 text-sm text-gray-600">
                        <input type="file" id="fileElement" accept="image/*" class="hidden"
                               @change="handleFileInput($event)">
                        <label for="fileElement"
                               class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition duration-150 ease-in-out">Upload
                            a file</label>
                        or drag and drop
                    </p>
                    <p class="mt-1 text-xs text-gray-500" :class="valid ? 'text-gray-500' : 'text-red-500'">
                        PNG, JPG, GIF up to 1MB
                    </p>
                    <p v-if="!valid" class="mt-1 text-xs text-red-500">
                        Image is too big!
                    </p>
                </div>
                <div v-show="uploadedSource != null">
                    <img :src="uploadedSource" class="h-24">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FormUpload",
        props: {
            existing: String
        },
        data() {
            return {
                highlight: false,
                uploadedSource: null,
                valid: true
            }
        },
        methods: {
            showExisting() {
                return this.existing && !this.uploadedSource;
            },
            handleDrop(e) {
                let dt = e.dataTransfer;
                let files = dt.files;

                this.highlight = false;
                this.handleFile(files[0]);
            },
            handleFileInput(e) {
                let files = e.target.files;
                this.handleFile(files[0]);
            },
            handleFile(file) {

                if (file.size > 1048576) {
                    this.valid = false;
                } else {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);

                    reader.onloadend = () => {
                        this.uploadedSource = reader.result;
                        this.$emit('file-selected', [file, reader.result]);
                    };
                }
            }
        }
    }
</script>
